import React, {useEffect, useState} from 'react';
import { connect, useDispatch, useSelector } from "react-redux";
import { Field, reduxForm } from "redux-form";
import {
    renderField,
    required,
    renderToggle,
    renderTextArea,
} from "../../../utils/formValidations.js";
import { Groups, Group, FormFooter } from "../../../components/Form/Form.js"
import { getEgressGateways, getEgressProviders } from '../../../actions/actionEgressProvider.js';

let EgressGatewayForm = (props) => {
    const { handleSubmit } = props
    const dispatch = useDispatch()
    const egress_gateways = useSelector(state => state.egress_provider.egress_gateways) || null
    const egress_providers = useSelector(state => state.egress_provider.egress_providers) || null
    const [currentEgressProvider, setCurrentEgressProvider] = React.useState(null);
    const currentProvider = props.match.params.id
    const [isManaged, setIsManaged] = useState(null)

    useEffect(() => {
        if (props.fromUpdate) {
            dispatch(getGateways())
        }
        props.change('egress_provider_id', currentProvider)
        if (!egress_providers) {
            dispatch(getEgressProviders())
        }
    }, []);

    useEffect(() => {
        if (egress_providers) {
            const egressProvider = egress_providers.find(provider => provider.egress_provider_id === currentProvider);
            setCurrentEgressProvider(egressProvider)
            if (egressProvider.egress_provider_type === 'tailscale') {
                props.autofill('config', undefined)
            }
        }
    }, [egress_providers]);

    useEffect(() => {
        if (currentEgressProvider && currentEgressProvider.is_managed) {
            setIsManaged(true)
        } else {
            setIsManaged(false)
        }
    }, [currentEgressProvider])

    const getGateways = () => {
        return getEgressGateways({
            egress_gateway_id: props.match.params.gateway_id
        })
    }

    useEffect(() => {
        if (props.fromUpdate && egress_gateways) {
            const currentGateway = props.match.params.gateway_id
            const currentEgressGateway = egress_gateways.find(gateway => gateway.egress_gateway_id === currentGateway);
            props.initialize({
                egress_provider_id: currentEgressGateway.egress_provider_id,
                egress_gateway_id: currentEgressGateway.egress_gateway_id,
                enabled: currentEgressGateway.enabled,
                name: currentEgressGateway.name,
                country: currentEgressGateway.country,
                city: currentEgressGateway.city,
                config: currentEgressGateway.config
            });

        }
    }, [egress_gateways]);

    return (
        <Groups onSubmit={handleSubmit(props.save)} section={props.section}>
            <Group title="general" description="general-description-gateway">

                <Field name="enabled"
                    id="enabled"
                    type="checkbox"
                    component={renderToggle}
                />

                <Field type="text"
                    name="name"
                    id="name"
                    component={renderField}
                    validate={required} required
                    disabled={isManaged}
                />
                <Field type="text"
                    name="country"
                    help="kb-26-2"
                    id="country"
                    component={renderField}
                    validate={required} required
                    disabled={isManaged}
                />
                <Field type="text"
                    name="city"
                    help="kb-26-3"
                    id="city"
                    component={renderField}
                    validate={required} required
                    disabled={isManaged}
                />
                {currentEgressProvider?.egress_provider_type !== 'tailscale' && !isManaged &&
                 <Field type="text"
                    name="config"
                    help="kb-26-4"
                    id="config"
                    component={renderTextArea}
                    validate={required} required
                />
                }
            </Group>
            <FormFooter cancel={() => props.history.push(`/update_egress_provider/${currentProvider}?tab=gateway`)} />
        </Groups>
    );
}

EgressGatewayForm = reduxForm({
    form: 'EgressGatewayForm'
})(EgressGatewayForm)

EgressGatewayForm = connect(  // eslint-disable-line
    state => ({
        initialValues: { enabled: true },
    })) 
(EgressGatewayForm); 

export default EgressGatewayForm
